import { api, apiDelete, apiGet, apiPost } from "@/lib/api";

export const INTEGRATION_PROVIDERS = [
  { id: "gmail", name: "Gmail" },
  { id: "outlook", name: "Outlook / Microsoft 365" },
  { id: "freee", name: "freee 会計" },
  { id: "moneyforward", name: "マネーフォワード" },
  { id: "kintone", name: "kintone" },
  { id: "salesforce", name: "Salesforce" },
] as const;

export type IntegrationProviderId = (typeof INTEGRATION_PROVIDERS)[number]["id"];

export interface PublicIntegration {
  id: string;
  can_read_items?: boolean;
  provider: string;
  status: string;
  installed_at: number;
  last_synced_at: number | null;
  account_email: string | null;
  account_label: string | null;
  last_error: string | null;
  last_sync: { fetched: number; emitted: number; errors: string[]; next_cursor: string | null } | null;
}

export interface ProviderCatalogEntry {
  configured: boolean;
  oauth: boolean;
}

export function listIntegrations() {
  return apiGet<{ integrations: PublicIntegration[]; providers: Record<string, ProviderCatalogEntry> }>("/v1/integrations");
}

export function connectIntegration(provider: string, body: { return_url?: string; extra?: Record<string, string> }) {
  return api<{ authorization_url?: string; url?: string }>(`/v1/integrations/${encodeURIComponent(provider)}/connect`, { method: "POST", body: JSON.stringify(body), credentials: "include" });
}

export function disconnectIntegration(id: string) {
  return apiDelete(`/v1/integrations/${encodeURIComponent(id)}`);
}

export function syncIntegration(provider: string) {
  return apiPost<{ ok: boolean; connection_id: string; fetched: number; emitted: number; errors: string[] }>(
    `/v1/integrations/${encodeURIComponent(provider)}/sync`,
    {},
  );
}

export interface SyncedItem {
  external_id: string;
  title: string | null;
  body_preview: string | null;
  url: string | null;
  seen_at: number;
}

export function listSyncedItems(provider: string) {
  return apiGet<{ items: SyncedItem[] }>(`/v1/integrations/${encodeURIComponent(provider)}/items`);
}
